import { render, staticRenderFns } from "./DeleteAccount.vue?vue&type=template&id=27112ac4&scoped=true"
import script from "./DeleteAccount.vue?vue&type=script&lang=js"
export * from "./DeleteAccount.vue?vue&type=script&lang=js"
import style0 from "./DeleteAccount.vue?vue&type=style&index=0&id=27112ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27112ac4",
  null
  
)

export default component.exports